import * as React from 'react';
import { TableColumnProps } from '../types';
import { DueDateModel } from '../../../../api/models/DueDateModel';
import { DueDate } from '../../../dueDate';

export const DueDateColumn = (props: TableColumnProps) => {
    const { colProps, rowKey, row } = props;
    const value = row[colProps.field];
    const dueDateModel: DueDateModel = value;
    const key = `${colProps.field}-${rowKey}`;

    return <div key={key} data-header={colProps.dataHeader}><DueDate {...dueDateModel}/></div>;
};
